import React from "react";
import { Grid, Paper, Typography, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// logo
import logo from "./logo.svg";
import Cookies from "universal-cookie";

export default function Error() {
  var classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <div className={classes.logotype}>
        <img className={classes.logotypeIcon} style={{ width: 400, marginTop: 100, marginLeft: 50 }} src={require('../../images/logo_sisma.png')} alt="logo" />
      </div>
      <Paper classes={{ root: classes.paperRoot }}>
        <Typography
          variant="h1"
          color="primary"
          className={classnames(classes.textRow, classes.errorCode)}
        >
          404
        </Typography>
        <Typography variant="h5" color="primary" className={classes.textRow}>
          La pagina che stai cercando non esiste
        </Typography>
        <Typography
          variant="h6"
          color="text"
          colorBrightness="secondary"
          className={classnames(classes.textRow, classes.safetyText)}
        >
          Clicca qui sotto per tornare nell'area protetta
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className={classes.backButton}
          onClick={() => {

            const cookies = new Cookies();
            let username = cookies.get('username');
            let token = cookies.get('token'); 

            if (!username || !token) {
              cookies.remove('token');
              cookies.remove('username');
              window.location.href = '/#/login';
              return;
            }

            let tipoUtente = cookies.get('userType');

            var ref = "";
            switch(tipoUtente) {
              case "0":
                ref = "#/app/dashboard";
                break;
              case "1":
                ref = "#/tecnico/dashboard";
                break;
              case "2":
                ref = "#/magazzino/dashboard";
                break;
              case "3":
                ref = "#/commerciale/dashboard";
                break
              case "4":
                ref = "#/service/dashboard";
                break
            }

            window.location.href = ref;

          }}
        >
          Torna alla dasboard
        </Button>
      </Paper>
    </Grid>
  );
}
